var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#29EFA8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1936 15.4673L24.2699 16.3905L23.3468 15.4673C20.3145 12.435 15.3987 12.435 12.3664 15.4673C9.44874 18.385 9.32294 23.074 12.0758 26.1476C15.3751 29.8325 19.1049 33.2587 23.2339 36.4458C23.8417 36.9153 24.6987 36.9153 25.3065 36.4458C29.4355 33.2587 33.1653 29.8325 36.464 26.1476C39.2169 23.074 39.0917 18.385 36.174 15.4673C33.1417 12.435 28.2259 12.435 25.1936 15.4673",
    fill: "#29EFA8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterHeart);
export default __webpack_public_path__ + "static/media/footerHeart.226f35556ed6f150617220e313600d85.svg";
export { ForwardRef as ReactComponent };